import { yupResolver } from "@hookform/resolvers/yup";
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { DeleteIcon } from "../../../assets/CommonAssets";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import DatePickerFieldNew from "../../../common/components/FormFields/DatePickerFieldNew";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import {
  errorAlert,
  successAlert,
  warningAlert,
} from "../../../common/components/Toasts/CustomToasts";
import {
  deleteXMlData,
  getFunctionalityDropdown,
  getPaymentByXMLId,
  getSubFunctionalityDropdown,
  getXMLGenerationTallyList,
  saveDoctorBillBankPaymentXMLGenerateForTally,
  saveDoctorBillXMLGenerateForTally,
  saveInvXMLGenerateForTally,
  saveIpdBillXMLGenerarteForTally,
  saveIpdCancellationBillXMLGenerarteForTally,
  saveIpdReceiptBillXMLGenerarteForTally,
  saveJournalXMLGenerarteForTally,
  saveOpdCancellationBillXMLGenerarteForTally,
  saveOPDXMLGenerateForTally,
  saveVoucherXMLGenerarteForTally,
} from "../../services/XMLGenerationForTallyService/XMLGenerationForTallyService";

import CommonBackDrop from "../../../common/components/CommonBackDrop/CommonBackDrop";
import CommonDynamicTablePaginationNew from "../../../common/components/CommonTable/CommonDynamicTablePaginationNew";
import LoadingSpinner from "../../../common/components/loadingspinner/loadingSpinner";
import TallyInterfaceModal from "./TallyInterfaceModal";
import { fetchUserActionsByMenuId } from "../../../commonServices/functionalityServices/FunctionalityServices";
import { useLocation } from "react-router-dom";
import apiClient, { baseUrl } from "../../../http-common";
import authHeader from "../../../authentication/authservices/auth-header";
import axios from "axios";
import { MdDownloadForOffline } from "react-icons/md";
import { Tooltip } from "@mui/material";

function XMLGenerationForTally() {
  const location = useLocation();
  const uploadXMLRef = useRef(null);
  const [fileUploadedList, setfileUploadedList] = useState([]);
  const [formData, setFormData] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const [functionalityDropdown, setFunctionalityDropdown] = useState([]);
  const [subFunctionalityDropdown, setSubFunctinalityDropdown] = useState([]);
  const [spinner, setSpinner] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
  const [openTallyData, setOpenTallyData] = useState(false);
  const [openBackdrop, setOpenBackdrop] = useState(false);
  const [userActions, setUserActions] = useState([]);
  const schema = yup.object({
    functionality: yup.object().nullable().required(),
    startDate: yup.date().nullable().required(),
    endDate: yup.date().nullable().required(),
  });

  const defaultValues = {
    functionality: null,
    subFunctionality: null,
    startDate: new Date(),
    endDate: new Date(),
  };
  const {
    control,
    register,
    setValue,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: defaultValues,
    mode: "onChange",
    resolver: yupResolver(schema),
  });

  const watchFunctinality = watch("functionality");
  const watchSubFunactionality = watch("subFunctionality");
  console.log("watchFunctinality", watchFunctinality, watchSubFunactionality);

  useEffect(() => {
    getFunctionalityDropdown()
      .then((response) => response.data)
      .then((res) => {
        setFunctionalityDropdown(res.result);
      })
      .catch((error) => error);
  }, []);

  const populateTable = () => {
    setSpinner(true);
    getXMLGenerationTallyList()
      .then((response) => response.data)
      .then((data) => {
        setfileUploadedList(data?.result);
        setSpinner(false);
      })
      .catch((error) => {
        errorAlert(error);
        setSpinner(false);
      });
  };

  const onSubmit = (data) => {
    const formData = {
      functionality: data?.functionality?.id,
      reportType: data?.subFunctionality?.id,
      startDate: data?.startDate
        ? format(new Date(data.startDate), "yyyy-MM-dd")
        : null,
      endDate: data?.endDate
        ? format(new Date(data.endDate), "yyyy-MM-dd")
        : null,
    };
    console.log("Tally Form Data :", formData);

    setFormData(formData);
    setOpenConfirmationModal(true);
  };
  console.log("watchFunctinality", watchFunctinality);

  const handleGenerateXML = () => {
    setOpenConfirmationModal(false);
    setOpenBackdrop(true);
    if (watchFunctinality.label === "OPD") {
      saveOPDXMLGenerateForTally(formData)
        .then((response) => response.data)
        .then((res) => {
          reset(defaultValues);
          successAlert(res.message);
          setOpenBackdrop(false);
          populateTable();
        })
        .catch((error) => {
          errorAlert(error.message);
          setOpenBackdrop(false);
        });
    } else if (
      watchFunctinality.label === "Inventory (Pharmacy)" &&
      watchSubFunactionality?.id === 14
    ) {
      saveDoctorBillBankPaymentXMLGenerateForTally(formData)
        .then((response) => response.data)
        .then((res) => {
          reset(defaultValues);
          successAlert(res.message);
          setOpenBackdrop(false);
          populateTable();
        })
        .catch((err) => {
          errorAlert(err.message);
          setOpenBackdrop(false);
        });
    } else if (
      (watchFunctinality.label === "Inventory (Pharmacy)" &&
        watchSubFunactionality?.id !== 14) ||
      watchSubFunactionality?.id === 25 ||
      watchSubFunactionality?.id === 26
    ) {
      saveInvXMLGenerateForTally(formData)
        .then((response) => response.data)
        .then((res) => {
          reset(defaultValues);
          successAlert(res.message);
          setOpenBackdrop(false);
          populateTable();
        })
        .catch((err) => {
          errorAlert(err.message);
          setOpenBackdrop(false);
        });
    } else if (
      watchFunctinality.label === "Doctor Bill" &&
      (watchSubFunactionality?.id === 16 || watchSubFunactionality?.id === 18)
    ) {
      saveDoctorBillXMLGenerateForTally(formData)
        .then((response) => response.data)
        .then((res) => {
          reset(defaultValues);
          successAlert(res.message);
          setOpenBackdrop(false);
          populateTable();
        })
        .catch((err) => {
          errorAlert(err.message);
          setOpenBackdrop(false);
        });
    } else if (
      watchFunctinality.label === "Doctor Bill" &&
      (watchSubFunactionality?.id === 17 || watchSubFunactionality?.id === 19)
    ) {
      saveDoctorBillBankPaymentXMLGenerateForTally(formData)
        .then((response) => response.data)
        .then((res) => {
          reset(defaultValues);
          successAlert(res.message);
          setOpenBackdrop(false);
          populateTable();
        })
        .catch((err) => {
          errorAlert(err.message);
          setOpenBackdrop(false);
        });
    } else if (watchFunctinality.label === "OPD Cancellation") {
      saveOpdCancellationBillXMLGenerarteForTally(formData)
        .then((response) => response.data)
        .then((res) => {
          reset(defaultValues);
          successAlert(res.message);
          setOpenBackdrop(false);
          populateTable();
        })
        .catch((err) => {
          errorAlert(err.message);
          setOpenBackdrop(false);
        });
    } else if (
      watchFunctinality?.label === "IPD" &&
      watchSubFunactionality?.id !== 20 &&
      watchSubFunactionality?.id !== 21
    ) {
      saveIpdBillXMLGenerarteForTally(formData)
        .then((response) => response.data)
        .then((res) => {
          reset(defaultValues);
          successAlert(res.message);
          setOpenBackdrop(false);
          populateTable();
        })
        .catch((err) => {
          errorAlert(err.message);
          setOpenBackdrop(false);
        });
    } else if (
      watchFunctinality?.label === "IPD" &&
      (watchSubFunactionality?.id === 20 || watchSubFunactionality?.id === 21)
    ) {
      saveIpdReceiptBillXMLGenerarteForTally(formData)
        .then((response) => response.data)
        .then((res) => {
          reset(defaultValues);
          successAlert(res.message);
          setOpenBackdrop(false);
          populateTable();
        })
        .catch((err) => {
          errorAlert(err.message);
          setOpenBackdrop(false);
        });
    } else if (
      watchFunctinality?.label === "IPD Cancellation" &&
      (watchSubFunactionality?.id === 27 || watchSubFunactionality?.id === 28)
    ) {
      saveIpdCancellationBillXMLGenerarteForTally(formData)
        .then((response) => response.data)
        .then((res) => {
          reset(defaultValues);
          successAlert(res.message);
          setOpenBackdrop(false);
          populateTable();
        })
        .catch((err) => {
          errorAlert(err.message);
          setOpenBackdrop(false);
        });
    } else if (
      watchFunctinality?.label === "Voucher" &&
      watchSubFunactionality?.id === 30
    ) {
      saveVoucherXMLGenerarteForTally(formData)
        .then((response) => response.data)
        .then((res) => {
          reset(defaultValues);
          successAlert(res.message);
          setOpenBackdrop(false);
          populateTable();
        })
        .catch((err) => {
          errorAlert(err.message);
          setOpenBackdrop(false);
        });
    } else if (
      watchFunctinality?.label === "Voucher" &&
      watchSubFunactionality?.id === 29
    ) {
      saveJournalXMLGenerarteForTally(formData)
        .then((response) => response.data)
        .then((res) => {
          reset(defaultValues);
          successAlert(res.message);
          setOpenBackdrop(false);
          populateTable();
        })
        .catch((err) => {
          errorAlert(err.message);
          setOpenBackdrop(false);
        });
    } else {
      warningAlert("Work In Progress");
      reset(defaultValues);
      setOpenBackdrop(false);
    }
  };

  const handleDelete = () => {
    setOpenBackdrop(true);
    deleteXMlData(selectedFile)
      .then((response) => response.data)
      .then((res) => {
        successAlert(res.message);
        setOpenConfirmationModal(false);
        setSelectedFile(null);
        setOpenBackdrop(false);
        populateTable();
      })
      .catch((error) => {
        errorAlert(error.message);
        setOpenBackdrop(false);
      });
  };

  // const handleDownload = (xmlContent) => {
  //   const now = new Date();
  //   const formattedDateTime = format(now, "dd-MM-yyyy h.mmaa");
  //   // const filename = `XML Document ${formattedDateTime}.xml`;
  //   const filename = `XML ${
  //     xmlContent?.Description +
  //     " " +
  //     xmlContent?.["Start Date"] +
  //     "/" +
  //     xmlContent?.["End Date"]
  //   }.xml`;
  //   const blob = new Blob([xmlContent?.XML], { type: "application/xml" });
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = filename;
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  //   URL.revokeObjectURL(link.href);
  // };

  const handleXMLDownload = (row) => {
    getPaymentByXMLId(row?.Id).then((response) => {
      console.log("getPaymentByXMLId", response?.data?.result);
      if (response?.data?.result !== null) {
        const now = new Date();
        const formattedDateTime = format(now, "dd-MM-yyyy h.mmaa");
        // const filename = `XML Document ${formattedDateTime}.xml`;
        const filename = `XML ${row?.Description + " " + row?.["Start Date"] + "/" + row?.["End Date"]
          }.xml`;
        const blob = new Blob([response?.data?.result], {
          type: "application/xml",
        });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      }
    });
  };

  const handleServiceRatesUpload = (e) => {
    const file = e?.target?.files[0];
    // Check if a file is selected
    if (!file) {
      return errorAlert("No file selected.");
    }
    const formData = new FormData();
    formData.append("file", file);
    const url = `${baseUrl}/tally/upload`;
    console.log("Selected file:", url);
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: authHeader()?.Authorization,
      },
    };
    setOpenBackdrop(true);
    // Perform the upload request
    axios
      .post(url, formData, config)
      .then((response) => {
        successAlert(response?.data?.message);
        setOpenBackdrop(false);
      })
      .catch((error) => {
        console.error("Upload error:", error);
        errorAlert(
          error?.response?.data?.message ||
          error?.message ||
          "An error occurred.",
        );
        setOpenBackdrop(false);
      });
  };

  // const renderInput = (row, index, header) => {
  //   return (
  //     <div key={index}>
  //       {header === "XML" && row?.XML !== null && (
  //         <button
  //           type="button"
  //           onClick={() => handleDownload(row)}
  //           className="underline font-semibold text-customBlue"
  //         >
  //           Download
  //         </button>
  //       )}
  //     </div>
  //   );
  // };

  function renderActions(row, index) {
    return (
      <div key={index} className="flex space-x-4">
        {userActions.map((action, i) => (
          <>
            {action.isAction && action.action === "Delete" ? (
              <Tooltip title="Delete">
                <button
                  title="Delete"
                  type="button"
                  onClick={() => {
                    setSelectedFile(row.Id);
                    setOpenConfirmationModal(true);
                  }}
                >
                  <DeleteIcon />
                </button>
              </Tooltip>
            ) : null}
          </>
        ))}
        <Tooltip title="Download XML">
          <button
            type="button"
            onClick={() => {
              handleXMLDownload(row);
            }}
          >
            <MdDownloadForOffline size={24} className="text-blue-500" />
          </button>
        </Tooltip>
      </div>
    );
  }

  useEffect(() => {
    if (watchFunctinality !== null) {
      getSubFunctionalityDropdown(watchFunctinality?.id)
        .then((response) => response.data)
        .then((res) => {
          setSubFunctinalityDropdown(res?.result);
        })
        .catch((error) => error);
    }
  }, [watchFunctinality]);

  useEffect(() => {
    populateTable();

    fetchUserActionsByMenuId(location?.state?.menuId)
      .then((response) => response.data)
      .then((res) => {
        setUserActions(res.result);
      });
  }, []);

  console.log("fileUploadedList.length > 0", fileUploadedList.length > 0);

  return (
    <div className="w-full  pt-12">
      {/* {CommonHeading("XML Generation for Tally")} */}
      <div className="flex justify-center font-bold text-xl my-2 px-3">
        XML Generation for Tally
      </div>

      <form
        onSubmit={handleSubmit(onSubmit)}
        className="grid grid-cols-2 lg:grid-cols-4 items-center gap-2"
      >
        <div>
          <DropdownField
            name="functionality"
            control={control}
            placeholder="Functionality"
            dataArray={functionalityDropdown}
            error={errors?.functionality}
            inputRef={{
              ...register("functionality", {
                onChange: (e) => {
                  if (e.target.value) {
                    setValue("subFunctionality", null);
                  }
                },
              }),
            }}
          />
        </div>
        {subFunctionalityDropdown.length > 0 && (
          <div>
            <DropdownField
              name="subFunctionality"
              control={control}
              placeholder="Sub Functionality"
              dataArray={subFunctionalityDropdown}
              error={errors?.subFunctionality}
            />
          </div>
        )}
        <div className="flex space-x-2">
          <DatePickerFieldNew
            control={control}
            name={"startDate"}
            label={"Start Date"}
            slotProps={{ textField: { size: "small" } }}
            inputFormat="dd-MM-yyyy"
            error={errors?.startDate}
          />
          <DatePickerFieldNew
            control={control}
            name={"endDate"}
            label={"End Date"}
            slotProps={{ textField: { size: "small" } }}
            inputFormat="dd-MM-yyyy"
            error={errors?.endDate}
            minDate={watch("startDate")}
          />
        </div>

        <div className="col-span-2 flex gap-2 justify-end">
          <CommonButton
            label={"Reset"}
            className={"text-customRed border border-customRed"}
            type={"button"}
            onClick={() => reset(defaultValues)}
          />
          <CommonButton
            label={"Generate XML"}
            className={"bg-customBlue text-white"}
            type={"submit"}
          />
          {userActions?.map((action) => (
            <>
              {action?.isAction === false &&
                action?.action === "View Tally Data" && (
                  <CommonButton
                    label="Tally Data"
                    className={"bg-customBlue text-white"}
                    type={"button"}
                    onClick={() => {
                      setOpenTallyData(true);
                    }}
                  />
                )}
              {action?.isAction === false &&
                action?.action === "View Tally Data" && (
                  <>
                    <CommonButton
                      label="Upload XML"
                      className={"bg-customGreen text-white"}
                      type="button"
                      onClick={() => {
                        uploadXMLRef?.current?.click();
                      }}
                    />
                    <input
                      ref={uploadXMLRef}
                      type="file"
                      accept=".xml"
                      className="hidden"
                      onChange={(e) => {
                        handleServiceRatesUpload(e);
                      }}
                    />
                  </>
                )}
            </>
          ))}
        </div>
      </form>

      {spinner && (
        <div className="flex justify-center h-96">
          <LoadingSpinner />
        </div>
      )}

      <div className="mt-4">
        {fileUploadedList.length > 0 && !spinner ? (
          <CommonDynamicTablePaginationNew
            dataResult={fileUploadedList}
            // renderInput={renderInput}
            removeHeaders={["FunctionalityId", "Id", "XML"]}
            // editableColumns={["XML"]}
            highlightRow={false}
            renderActions={renderActions}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            count={fileUploadedList?.length}
            setRowsPerPage={setRowsPerPage}
            populateTable={populateTable}
          />
        ) : (
          <>
            {!spinner && (
              <div className="flex justify-center">
                <p className="text-center font-bold  my-32">
                  No Records Found
                  <span className="animate-ping font-bold text-lg">...</span>
                </p>
              </div>
            )}
          </>
        )}
      </div>
      {/* <Modal
                open={openModal}
                aria-labelledby="xml-file-viewer"
                aria-describedby="modal to view xml file content"
            >
                <Box sx={ModalStyle} className="max-h-[90%] w-[70%] space-y-2 overflow-auto rounded">
                    <div className="flex justify-between items-center">
                        <p className='font-semibold'>File Viewer</p>
                        <button
                            onClick={() => {
                                setOpenModal(false);
                                setSelectedFile(null);
                            }}
                            type='button'
                        >
                            <CloseModalIcon />
                        </button>
                    </div>
                    <div className="p-2  bg-gray-100 max-h-[75vh] overflow-auto rounded-md border border-gray-300">
                        {selectedFile && (
                            <pre className="whitespace-pre-wrap break-words text-sm text-gray-800">
                                {atob(selectedFile.split(",")[1])}
                            </pre>
                        )}
                    </div>
                </Box>
            </Modal> */}
      {openTallyData && (
        <TallyInterfaceModal
          openTallyData={openTallyData}
          setOpenTallyData={setOpenTallyData}
        />
      )}
      {openBackdrop && <CommonBackDrop openBackdrop={openBackdrop} />}
      {openConfirmationModal && (
        <ConfirmationModal
          confirmationOpen={openConfirmationModal}
          confirmationHandleClose={() => setOpenConfirmationModal(false)}
          confirmationLabel="Confirmation"
          confirmationMsg={`Are you sure ?`}
          confirmationSubmitFunc={
            selectedFile === null ? handleGenerateXML : handleDelete
          }
          confirmationButtonMsg="Confirm"
        />
      )}
    </div>
  );
}

export default XMLGenerationForTally;
